var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"10px"}},[_c('div',{staticClass:"echarts",staticStyle:{"width":"100%","height":"350px"}},[_c('v-chart',{attrs:{"option":_vm.options,"id":"geomap","resizable":true,"theme":"infographic"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }